import { render, staticRenderFns } from "./GenerateSubdomain.vue?vue&type=template&id=85cf5b98&scoped=true"
import script from "./GenerateSubdomain.vue?vue&type=script&lang=js"
export * from "./GenerateSubdomain.vue?vue&type=script&lang=js"
import style0 from "./GenerateSubdomain.vue?vue&type=style&index=0&id=85cf5b98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85cf5b98",
  null
  
)

export default component.exports